<template>
    <filters
        :filters="filters"
        :is-loading="isLoading"
        :results-total="resultsTotal"
    >
        <template slot="menu">
            <slot name="menu" />
        </template>

        <template slot="filters">
            <div
                v-for="(category, index) in categories.slice(0, 1)"
                :key="`category-group-${index}`"
                class="form-group"
            >
                <h4>
                    <a
                        :href="category.url"
                        :class="[{ active: menuItemIsActive(category.url) }, 'filter-category-title']"
                    >
                        {{ category.title }}
                    </a>
                </h4>
                <ul class="filter-list list">
                    <li
                        v-for="(subcategory, index) in category.items"
                        :index="`subcategory-${index}`"
                    >
                        <a
                            :href="subcategory.url"
                            :class="{ active: menuItemIsActive(subcategory.url) }"
                        >
                            {{ subcategory.title }}
                        </a>

                        <ul
                            v-if="subcategory.items"
                            class="filter-list list"
                        >
                            <li
                                v-for="(sub_subcategory, index) in subcategory.items"
                                :index="`sub_subcategory-${index}`"
                            >
                                <a
                                    :href="sub_subcategory.url"
                                    :class="{ active: menuItemIsActive(sub_subcategory.url) }"
                                >
                                    {{ sub_subcategory.title }}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div
                v-for="(filterGroup, index) in categoriesExcluded"
                :key="`filter-group-${index}`"
                class="form-group"
            >
                <h4>{{ filterGroup.title }}</h4>

                <div
                    v-if="filterGroup.key === 'brand'"
                    :class="[{ active: query.brand_search },'form-group']"
                >
                    <input
                        v-model="query.brand_search"
                        @input="handleFilter"
                        type="text"
                        class="form-control"
                        name="brand_search"
                        id="brand_search"
                        :placeholder="$t('category.search_by_brand')"
                    >
                    <label for="brand_search">
                        {{ $t('category.search_by_brand') }}
                    </label>
                </div>

                <filter-items
                    :filter-items="filterGroup.items"
                    :filter-key="filterGroup.key"
                />
            </div>

            <div class="form-group">
                <h4>{{ $t('category.search_by_article_number') }}</h4>
                <div :class="[{ active: query.article_number },'form-group']">
                    <input
                        v-model="query.article_number"
                        @input="handleFilter"
                        type="text"
                        class="form-control"
                        name="article_number"
                        id="article_number"
                        :placeholder="$t('category.search_by_article_number')"
                    >
                    <label for="article_number">
                        {{ $t('category.search_by_article_number') }}
                    </label>
                </div>
            </div>
        </template>
    </filters>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Filters from '@/_vue/components/ui/filters';
    import FilterItems from '@/_vue/components/ui/filter-items';

    export default {
        name: 'SearchFilters',
        components: {
            Filters,
            FilterItems,
        },
        props: {
            filtersUrl: {
                required: true,
            },

            resultsUrl: {
                required: true,
            },
        },
        created() {
            this.setFiltersDefaults({
                filtersRoute: this.filtersUrl,
                resultsRoute: this.resultsUrl,
            });
            this.getFilters();
        },
        computed: {
            ...mapState('filters', {
                filters: 'filters',
                isLoading: 'isLoading',
                originalQuery: 'query',
                queryDefaults: 'queryDefaults',
                resultsTotal: 'resultsTotal',
            }),

            ...mapGetters('filters', [
                'categories',
                'categoriesExcluded',
            ]),
        },
        methods: {
            ...mapActions('filters', [
                'getFilters',
                'getResults',
            ]),

            ...mapMutations('filters', [
                'setFiltersDefaults',
                'updateQuery',
            ]),

            cloneQuery() {
                this.query = JSON.parse(JSON.stringify(this.originalQuery));
            },

            handleFilter() {
                clearTimeout(this.debouncer);

                this.debouncer = setTimeout(() => {
                    this.query.page = 1;
                    this.updateQuery(this.query);
                    this.getResults();
                }, 300);
            },

            menuItemIsActive(url) {
                return window.location.pathname === url;
            },
        },
        watch: {
            originalQuery: {
                handler: 'cloneQuery',
                immediate: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form-group {
        margin-bottom: 24px;

        &:last-child {
            margin-bottom: 0;
        }

        .form-group {
            margin-bottom: 12px;
        }
    }
</style>
